import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mountpoint-connection-setup-dialog',
  templateUrl: './mountpoint-connection-setup-dialog.component.html',
  styleUrls: ['./mountpoint-connection-setup-dialog.component.scss']
})
export class MountpointConnectionSetupDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<MountpointConnectionSetupDialogComponent>
  ) {
  }

  close(): void {
    this.dialogRef.close();
  }
}


